// This file is here because the nhweb-shared components have a dependency on it,
// since we won't be testing and want consistency between envs, we'll hardcode as false
export const isDevelopmentBuild = false;
